import React from "react";
import { Routes, Route } from "react-router-dom";
import ScrollToHash from "./components/ScrollToHash";
import Home from "./pages/Home";
import SponsorsDirectory from "./pages/SponsorsDirectory";

export default function App() {
  return (
    <>
      <ScrollToHash />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/sponsors" element={<SponsorsDirectory />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </>
  );
}
